import { render, staticRenderFns } from "./form-photo-upload.vue?vue&type=template&id=aad5fc4e&scoped=true&"
import script from "./form-photo-upload.vue?vue&type=script&lang=ts&"
export * from "./form-photo-upload.vue?vue&type=script&lang=ts&"
import style0 from "./form-photo-upload.vue?vue&type=style&index=0&id=aad5fc4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad5fc4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCol,VFileInput,VIcon})
